import { withTranslation } from "react-i18next";
import { Button, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";


const Setting = ({ props, show, onCloseClick, record, setRecord, onUpdateSetting }: any) => {
    const onChanged = (target: any, name: any) => {
        if (name == "hidden") {
            let field = { ...record, hidden: target.checked }
            setRecord(field)
        }
    }
    return (
        <Modal backdrop={"static"} id="myModal" isOpen={show} toggle={() => { onCloseClick(); }} centered>
            <ModalHeader className="modal-title fw-bold" id="myModalLabel" toggle={() => { onCloseClick(); }}>
            {props.t("properties.rules.field_settings")}
            </ModalHeader>
            <ModalBody className='text-center p-5'>
                <div className="vstack gap-3">
                    <div>
                        <div className="fs-16 mb-2 fw-bold text-start">
                        {props.t("properties.rules.field_visibility")}
                        </div>
                        <div className="hstack align-content-center gap-1 mb-1">
                            <Input className="mb-1 form-check-input" type="checkbox" name="show-informs" checked={record.hidden} onClick={(e) => onChanged(e.target, 'hidden')} />
                            <Label className="fs-16 mb-0 fw-medium">{props.t("properties.rules.hide_in_forms")}</Label>
                        </div>
                    </div>
                    <div className="hstack gap-2 mt-1 justify-content-center">
                        <Button className="btn btn-secondary" onClick={() => onUpdateSetting()}>
                        {props.t("common.offcanvas.save")}
                        </Button>
                        <Button color="danger" onClick={() => onCloseClick()} outline>
                        {props.t("common.offcanvas.cancel")}
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(Setting);